module.exports = __webpack_public_path__ + "static/media/icon_file_click.cbb8e2d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_file_click.svg
// module id = 141
// module chunks = 0